import * as RadixTabs from '@radix-ui/react-tabs'

import { WidgetFirstUse } from '../WidgetMessage'

export type Tab = {
  name: string | JSX.Element
  content: JSX.Element
}

interface Props {
  tabs: Tab[] | undefined
  firstUse?: boolean
  onTabClick?: (
    activeKey: string,
    e: React.KeyboardEvent | React.MouseEvent
  ) => void
  destroyInactiveTabPane?: boolean
  activeTabKey?: string
  [key: string]: unknown
}

const TabWidget = ({
  tabs,
  firstUse,
  onTabClick,
  destroyInactiveTabPane,
  activeTabKey,
}: Props) => {
  if (firstUse) {
    return (
      <div className="updated-component shadow-[0_4px_8px_0_rgba(14,31,53,0.08),0_1px_4px_0_rgba(14,31,53,0.12)]">
        <WidgetFirstUse shouldShowCreateCampaignButton className="m-6" />
      </div>
    )
  }

  const tabList = tabs ?? []

  return (
    <RadixTabs.Root
      className="updated-component"
      value={activeTabKey}
      defaultValue="0"
      onValueChange={(value) => onTabClick?.(value, {} as React.MouseEvent)}
    >
      <RadixTabs.List className="flex gap-2 overflow-x-auto max-w-[690px]">
        {tabList.map(({ name }, index) => (
          <RadixTabs.Trigger
            key={index}
            value={String(index)}
            data-cy={`tab-${index}`}
            data-testid={`tab-${index}`}
            className="bg-gold-50 text-gold-700 rounded-sm text-sm font-medium cursor-pointer px-2 py-3 line-clamp-1 data-[state=active]:text-base-700 data-[state=active]:bg-yellow-200"
          >
            {name}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {tabList.map(({ content }, index) => (
        <RadixTabs.Content
          key={index}
          value={String(index)}
          {...(!destroyInactiveTabPane ? { forceMount: true } : {})}
        >
          <div className="shadow-[0_4px_8px_0_rgba(14,31,53,0.08),0_1px_4px_0_rgba(14,31,53,0.12)]">
            {content}
          </div>
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  )
}

export default TabWidget
